import React,{useEffect} from "react";
import styles from './index.module.scss';
import { fileValidation } from '@src/services/FileValidation';
import { checkToken } from "@src/services/CheckToken";
import { useNavigate } from "react-router-dom";

//导入antd
import { Form, Input, Button, Upload, message } from 'antd';
//导入react-redux
import { useSelector, useDispatch } from "react-redux";
import { clearState } from "@src/store/actions/user";

import icon from '@imgs/fileValidation/pic.png'
import folderIcon from '@imgs/fileValidation/folder.png'

//导入组件
import { Disapproved } from './components/Disapproved';
import { Approved } from './components/Approved';

export const FileValidation = () => {
    //判断token是否过期
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const token = useSelector((state: any) => state.user.userInfo.token);
    useEffect(() => {
        checkToken({token}).then(res => {
            if(res.data === false) {
                //token过期
                message.error('登录已过期，请重新登录');
                dispatch(clearState());
                navigate('/');
            }
        })
    }, [])
    //input框的值
    const [uploadFileName, setUploadFileName] = React.useState('');
    //isPending判断加载图片
    const [isPending, setIsPending] = React.useState(false);
    //验证弹窗
    const [errMsg, setErrMsg] = React.useState('');
    const [disapproved, setDisapproved] = React.useState(false);
    const [approved, setApproved] = React.useState(false);
    //表单提交的方法
    const onFinish = (values: any) => {
        //loading
        setIsPending(true);
        //新建一个FormData对象
        const formData = new FormData();
        formData.append('file', values.file.file);
        formData.append('txId', values.txId); 
        formData.append('isShowMsg', 'false');
        //调用文件验证接口
        fileValidation(formData).then(res => {
            if(res.code === '0') {
                //验证成功
                setApproved(true);
            }
        }).catch((err: any) => { 
            //验证失败
            setErrMsg(err.response.data.msg);
            setDisapproved(true);
        }).finally(() => {
            //loading
            setIsPending(false);
        })
    };

    //上传文件方法,手动上传
    const beforeUpload = (info: any) => {
        setUploadFileName(info.name);
        return false;
    }
    

    return (
    <div className={styles.forensics}>
        {/* 背景图片 */}
        <img src={require('@imgs/fileValidation/bg.png').default} className={styles.bg} alt=""/>
        {/* 验证失败的弹窗 */}
        <Disapproved disapproved={disapproved} setDisapproved={setDisapproved} errMsg={errMsg} />
        {/* 验证成功的弹窗 */}
        <Approved approved={approved} setApproved={setApproved} />
        <div className={styles.content}>
            <img src={icon}/>
            <div className={styles.box}>
                {/* 文件验证表单,里面有文件验证的标题和输入存证编号input框和上传源文件的上传框 */}
                <div className={styles.form}>
                    <div className={styles.form_title}>文件验证</div>
                    <Form
                        name="fileValidation"
                        initialValues={{ remember: true }}
                        onFinish={onFinish} 
                    >
                        <Form.Item
                            name="txId"
                            rules={[{ required: true, message: '请输入存证编号!' }]}
                        >
                            <Input className={styles.form_input} placeholder="请输入存证编号" />
                        </Form.Item>
                        {/* 上传源文件 */}
                        <Form.Item
                            name="file"
                            rules={[{ required: true, message: '请点击选择源文件!' }]}
                        >
                            <Upload
                                name="upload"
                                action=''
                                beforeUpload={beforeUpload}
                                fileList={[]}
                                className={styles.upload}
                            >
                                <Input 
                                    disabled 
                                    className={styles.form_upload} 
                                    placeholder="请点击选择源文件" 
                                    value={uploadFileName}
                                />
                                <img src={folderIcon} />
                            </Upload>
                        </Form.Item>
                        <Form.Item>
                            <Button 
                                className={styles.form_submit} 
                                type="primary" 
                                htmlType="submit"
                                loading={isPending}
                            >
                                验真
                            </Button>
                        </Form.Item>
                    </Form>
                </div>          
            </div>
        </div>
    </div>
    )
}